"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFromTheme = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));

var RingCentralTheme = {
  COLOR: ui_symbols_1.COLOR,
  LAYOUT: ui_symbols_1.LAYOUT,
  LINE: ui_symbols_1.LINE,
  MOTION: ui_symbols_1.MOTION,
  PLANE: ui_symbols_1.PLANE,
  SCALE: ui_symbols_1.SCALE,
  TYPOGRAPHY: ui_symbols_1.TYPOGRAPHY
};

var getFromTheme = function getFromTheme(symbol, theme) {
  // (1) Custom theme
  if (theme && (0, lodash_get_1.default)(theme, symbol)) {
    return (0, lodash_get_1.default)(theme, symbol);
  } // (2) Hopin default


  if ((0, lodash_get_1.default)(RingCentralTheme, symbol)) {
    return (0, lodash_get_1.default)(RingCentralTheme, symbol);
  } // (3) No match
  // TODO: Add debugger.


  return '';
};

exports.getFromTheme = getFromTheme;